import type { Colors, DefaultTheme } from 'styled-components';
import { mapLightTheme } from './LightTheme';

const colors: Colors = {
  primary: {
    lighten: '#c60738',
    default: '#95052a',
    dim: 'rgba(149,5,42,0.4)',
    mute: 'rgba(149,5,42,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#e6e6e7',
    '010': '#f2f2f3',
    main: '#ffffff',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
  },
  green: {
    lighten: '#3ca371',
    default: '#2E7E57',
    dim: 'rgba(46,126,87,0.4)',
    mute: 'rgba(46,126,87,0.1)',
  },
  red: {
    lighten: '#ff0943',
    default: '#d50032',
    dim: 'rgba(213,0,50,0.4)',
    mute: 'rgba(213,0,50,0.1)',
  },
  yellow: {
    lighten: '#f1b000',
    default: '#BE8B00',
    dim: 'rgba(190,139,0,0.4)',
    mute: 'rgba(190,139,0,0.1)',
  },
  orange: {
    lighten: '#ff6511',
    default: '#dd4e00',
    dim: 'rgba(221,78,0,0.4)',
    mute: 'rgba(221,78,0,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9f73d7',
    default: '#844BCC',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const LightAbsaTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightABS',
});
